import { useEffect, useState } from 'react';

export const useIsSsr = (): boolean => {
  const [isSsr, setSsr] = useState(true);

  useEffect(() => setSsr(false), []);

  return isSsr;
};
